exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".font-500[data-v-cc0a8550]{font-weight:500}#ItemCreationRequestModalEdit .modal-dialog[data-v-cc0a8550],#ItemCreationRequestModalView .modal-dialog[data-v-cc0a8550]{min-width:80%}.dataTables_wrapper .dataTables_processing[data-v-cc0a8550]{position:absolute;top:50%;left:50%;width:30%;text-align:center;margin-left:-15%;margin-top:-25px;padding-top:30px;padding-bottom:50px;font-size:1.5em;background-color:none}", ""]);

// exports
